module.exports = __webpack_public_path__ + "static/media/Indonesia Tera.9f46a71f.png";